/**
 * Created by Ivan on 18.02.2026
 */

const IslandDecorationTutorial = function () {
    return new TutorialScenario(IslandDecorationTutorial.NAME, {
        manual: true,
        listSteps: IslandDecorationTutorial.listSteps
    });
};

IslandDecorationTutorial.listSteps = function () {
    const mission = IslandDecorationLogic.findRunningMission();
    const period = mission.logic.period;
    const name = `IslandDecoration${period.charAt(0).toUpperCase()}${period.slice(1)}`;
    const dialogue = bundles[`island_decoration_items_${period}`].jsons.island_decoration_dialogue_json.getJson();

    return [
        cleverapps.config.type === "merge2" && IslandDecorationTutorial.createSwitchModStep(),
        IslandDecorationTutorial.createCloseWindowStep(),
        IslandDecorationTutorial.createDialogueStep(dialogue),
        IslandDecorationTutorial.createWindowStep(mission),
        IslandDecorationTutorial.createStarsCounterStep(),
        IslandDecorationTutorial.createBuyItemStep(mission, { text: `${name}.Force0` }),
        IslandDecorationTutorial.createMagnifierStep({ text: `${name}.Force` })
    ].filter(Boolean);
};

IslandDecorationTutorial.createStarsCounterStep = function () {
    const options = {
        onStart: function () {
            const createForce = () => {
                const window = cleverapps.focusManager.currentWindow();

                this.force = cleverapps.forces.create(window.starsCounter, {
                    text: "IslandDecoration.Tutorial.StarsStep",
                    finger: false,
                    pointer: true,
                    closeByTouchInShadow: true
                }, {
                    importantNodes: [window.starsCounter],
                    highlights: [window.bg, window.starsCounter],
                    onSkip: () => cleverapps.tutorial.skip()
                });
            };

            if (!cleverapps.focusManager.currentWindow()) {
                this.finish();
                return;
            }

            cleverapps.focusManager.setEventNodes([]);

            cleverapps.tutorial.on("islandDecorationStarsShown", createForce, this);
            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                createForce();
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    };

    return new TutorialStep(options);
};

IslandDecorationTutorial.createDialogueStep = function (data) {
    return new TutorialStep({
        onStart: function () {
            let unit;

            if (cleverapps.config.type !== "merge2") {
                unit = Map2d.currentMap.listAvailableUnits({ code: "islanddecoration" })[0];
            }

            const showDialogue = () => {
                if (this.isFinished()) {
                    return;
                }

                const dialogue = new Dialogue(data, {
                    autoClose: true,
                    autoScroll: unit ? false : 3,
                    showUp: true
                });

                if (unit) {
                    unit.outline(true);

                    dialogue.on("showUp", () => {
                        this.highlighter = new UnitHighlighter(Map2d.currentMap.getMapView(), unit, { spotlight: true, ground: true });
                        dialogue.on("beforeClose", this.highlighter.unhighlight.bind(this.highlighter));
                    });

                    dialogue.on("afterClose", () => {
                        Map2dScroller.currentScroller.zoomOut(() => {
                            this.finish();
                        });
                    });

                    const dialogueView = new DialogueView(dialogue);
                    dialogueView._setGlobalZOrder(true);
                } else {
                    dialogue.on("afterClose", () => {
                        this.finish();
                    });

                    new DialogueView(dialogue);
                }
            };

            if (unit) {
                Map2dScroller.currentScroller.zoomIn(unit, {
                    zoom: 1.2,
                    callback: showDialogue
                });
            } else {
                showDialogue();
            }
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

IslandDecorationTutorial.createWindowStep = function (mission) {
    return new TutorialStep({
        onStart: function () {
            cleverapps.tutorial.on("window_shown", (options) => {
                if (options.windowName.includes("IslandDecorationWindow")) {
                    this.finish();
                } else if (options.windowName !== "RestartWindow") {
                    const focusStack = cleverapps.focusManager.stack.map((state) => state.focus);
                    cleverapps.throwAsync(`Opened unexpected window during IslandDecorationTutorial ${options.windowName}, focus stack: ${JSON.stringify(focusStack)}`);
                }
            }, this);
            cleverapps.focusManager.display({
                stack: true,
                focus: `${mission.name}Window`,
                action: function (f) {
                    const ViewConstructor = mission.view;
                    new ViewConstructor(mission);
                    cleverapps.focusManager.onceNoWindowsListener = f;
                }
            });
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

IslandDecorationTutorial.createBuyItemStep = function (mission, force) {
    let missionUpdated = false;
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        if (window) {
            const decorator = window.stages[0].items[0];

            if (!missionUpdated) {
                mission.update(decorator.item.price);

                mission.logEvent(Mission.EVENTS.MISSION_POINTS, { value: decorator.item.price });
                missionUpdated = true;
            }

            return cleverapps.forces.create(
                decorator.stateElement,
                force,
                {
                    highlights: [window.bg, cleverapps.Scenes.GetMovingNode()],
                    importantNodes: [decorator],
                    onSkip: () => cleverapps.tutorial.skip()
                }
            );
        } 
        return undefined;
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();
            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("buyIslandDecorationItem", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

IslandDecorationTutorial.createMagnifierStep = function (force) {
    const createForce = function () {
        const window = cleverapps.focusManager.currentWindow();
        if (window) {
            return cleverapps.forces.create(window.magnifier, force, {
                highlights: [window.bg],
                importantNodes: [ComponentUtils.findChildByName(window, "previewImage")],
                onSkip: () => cleverapps.tutorial.skip()
            });
        }
        return undefined;
    };

    return new TutorialStep({
        onStart: function () {
            this.force = createForce();
            if (!this.force) {
                this.finish();
                return;
            }

            cleverapps.tutorial.on("onResize", () => {
                this.force && this.force.close();
                this.force = createForce();
            }, this);

            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
            cleverapps.focusManager.setEventNodes([cleverapps.focusManager.currentWindow()]);
        }
    });
};

IslandDecorationTutorial.createGlassesStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }
            cleverapps.focusManager.setEventNodes([window]);
            window.controller.onPreviewClicked();
            cleverapps.tutorial.on("islandPreview", this.finish.bind(this), this);
            cleverapps.tutorial.on("window_closed", () => {
                this.finish();
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

IslandDecorationTutorial.createSwitchModStep = function () {
    return new TutorialStep({
        onStart: function () {
            if (Merge2.current.mode === Merge2.MODE_GAME) {
                Merge2.current.changeMode(Merge2.MODE_META, () => {});
            }
            this.finish();
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

IslandDecorationTutorial.createCloseWindowStep = function () {
    return new TutorialStep({
        onStart: function () {
            const window = cleverapps.focusManager.currentWindow();
            if (!window) {
                this.finish();
                return;
            }

            cleverapps.focusManager.setEventNodes([window]);

            cleverapps.tutorial.on("window_closed", (options) => {
                if (options.windowName !== window.name) {
                    cleverapps.focusManager.setEventNodes([window]);
                }
            }, this);

            cleverapps.tutorial.on("island_decoration_closed", () => {
                cleverapps.focusManager.setEventNodes([]);
                this.finish();
            }, this);
        },

        onFinish: function () {
            cleverapps.tutorial.startNextStep();
        }
    });
};

IslandDecorationTutorial.NAME = "island_decoration_tutorial";
